import React from 'react';
import PropTypes from 'prop-types';
import classes from './logo.module.scss';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'

const Logo = (props) => {
	const title = useSelector(state=> state.header.title, shallowEqual);

    return <div className={classes.wrapper}>
	            <p className={classes.title}>
	               {title}
	            </p>
	            <div className={classes.img__wrapper} href="">
	                <img className={classes.img} src="images/Flag_of_Ukraine_(with_coat_of_arms_2).svg.png" alt="flag of UA"/>
	            </div>
            </div>;
}

Logo.propTypes = {
    //products: PropTypes.array
}

export default Logo;